export default class GroundPileView
{
    constructor(_options)
    {
        this.pile = _options.pile
        this.factory = _options.factory
        this.container = this.factory.createGroundDrop()
        this.container.position.set(this.pile.x, this.pile.y, 0)
        this.lastCount = -1
        this.sync()
    }

    sync()
    {
        if(this.lastCount === this.pile.count)
            return
        this.lastCount = this.pile.count
        const contents = this.container.userData.contents
        for(const child of [...contents.children])
        {
            child.traverse((_child) =>
            {
                if(_child.isMesh)
                    _child.geometry.dispose()
            })
            contents.remove(child)
        }
        for(let index = 0; index < this.pile.count; index++)
        {
            const item = this.factory.createItem(this.pile.resource, 0.9)
            item.position.set((index % 3 - 1) * 0.31, (Math.floor(index / 3) % 3 - 1) * 0.27, Math.floor(index / 9) * 0.17)
            contents.add(item)
        }
    }

    update()
    {
        this.sync()
    }
}
